import is403 from '@Ravnur-Inc/core/transformers/error/is403';
import is404 from '@Ravnur-Inc/core/transformers/error/is404';
import $t from '@Ravnur-Inc/l10n/$t';
import { Logger } from '@Ravnur-Inc/logger';
import { convertFromError } from '@Ravnur-Inc/notifications/convertFromError';
import { showErrorNotification } from '@Ravnur-Inc/notifications/service';
import { Plugin } from 'vue';
import { useStore } from 'vuex-simple';

import store from './store';

export const BasePortalPlugin: Plugin = {
  install: function install(app) {
    app.mixin({
      beforeCreate() {
        this.$options.computed = this.$options.computed || {};
        this.$options.computed.store = () => useStore(store);
        this.$options.computed.$logger = () => new Logger(this.$options.name || 'Component');

        if (!this.$options.methods) {
          return;
        }

        // deprecated. using just inside template
        this.$options.methods.$t = $t;

        this.$options.methods.$processException = function $processException(e: unknown) {
          convertFromError(e).forEach(showErrorNotification);
        };

        this.$options.methods.$processPageException = function $processPageException(e: unknown) {
          if (is404(e)) {
            this.$router.replace({ name: '404' });
          } else if (is403(e)) {
            this.$router.replace({ name: '403' });
          } else {
            this.$processException(e);
          }
        };
      },
    });
  },
};
